export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./change-date.vue?vue&type=template&id=5902582a&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/change-date.vue?vue&type=template&id=5902582a&
// module id = 1688
// module chunks = 0